<template lang="pug">

.app-card.overflow-x-auto.links-styled-panel
  //- Header con título e ícono
  .d-flex.align-items-center.justify-content-between.tw-mb-3.tw-pb-2.tw-border-b.tw-border-gray-200
    .d-flex.align-items-center.tw-gap-2
      i.fa-solid.fa-images.tw-text-purple-600
      span.tw-font-semibold.tw-text-gray-700 Photos & Links
      span.tw-bg-purple-100.tw-text-purple-700.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-font-medium
        | {{ all_links.length }}
    edit-link-modal(
      :data-icon='"fa-solid fa-plus"'
      :data-label="$I18n.t('vue.links_detail_panel.add_link')"
      :data-mode='"new"'
      :data-item='JSON.stringify(empty_item)'
      :data-id='record.id' 
      :data-model='record.model'
      @updated='createNewLink'
    )
  
  //- Tabla mejorada
  table(v-if='!emptyItems' class="table table-hover links-styled-table")
    thead.tw-bg-gray-50
      tr
        th.tw-text-left
          .d-flex.align-items-center.tw-gap-1
            i.fa-solid.fa-link.tw-text-gray-400.tw-text-xs
            span {{$I18n.t('vue.links_detail_panel.table_header_link')}}
        th.tw-text-left
          .d-flex.align-items-center.tw-gap-1
            i.fa-solid.fa-align-left.tw-text-gray-400.tw-text-xs
            span {{$I18n.t('vue.links_detail_panel.table_header_description')}}
        th.tw-text-center.tw-w-24 Actions
    tbody
      tr(v-for="item in all_links" :key="item.id" class="tw-transition-colors hover:tw-bg-purple-50")
        td
          .d-flex.align-items-center.tw-gap-2
            //- Thumbnail si es imagen
            .tw-w-10.tw-h-10.tw-rounded.tw-bg-purple-100.tw-flex.tw-items-center.tw-justify-center.tw-flex-shrink-0(v-if="isImage(item.link)")
              i.fa-solid.fa-image.tw-text-purple-500
            .tw-w-10.tw-h-10.tw-rounded.tw-bg-gray-100.tw-flex.tw-items-center.tw-justify-center.tw-flex-shrink-0(v-else)
              i.fa-solid.fa-external-link.tw-text-gray-400
            a(:href="item.link" 
              target="_blank"
              class="app-btn-link-primary tw-text-sm tw-truncate tw-max-w-xs"
              :title="item.link"
            ) {{truncateUrl(item.link)}}
        td
          span.tw-text-gray-600.tw-text-sm {{ item.description || '—' }}
        td.tw-text-center
          .app-buttons-row.justify-content-center.tw-gap-1
            delete-link-modal(
              :data-id='item.id'
              @deleted='retrieveLinks'
            )
            edit-link-modal(
              :data-icon='"fa-solid fa-pencil"'
              :data-label='""'
              :data-mode='"edit"'
              :data-item='JSON.stringify(item)'
              @updated='updateLink'
            )
  
  //- Estado vacío mejorado
  .tw-text-center.tw-py-8(v-if='emptyItems')
    .tw-w-16.tw-h-16.tw-bg-purple-100.tw-rounded-full.tw-flex.tw-items-center.tw-justify-center.tw-mx-auto.tw-mb-3
      i.fa-solid.fa-images.tw-text-purple-400.tw-text-2xl
    p.tw-text-gray-500.tw-mb-0 {{$I18n.t('vue.links_detail_panel.empty_items')}}

</template>
<script>

import DeleteLinkModal from './delete-link-modal.vue'
import EditLinkModal from './edit-link-modal.vue'
import {BackendService} from '../../services';

export default {
  components:{
    'delete-link-modal':DeleteLinkModal,
    'edit-link-modal':EditLinkModal
  },
  props:{
    dataId: String,
    dataModel: String,
    dataOrder: String,
    dataItems: String,
    dataOtherOrders: String,
  },
  data: function(){
    return {
      state: {
        confirmed: false,
      },
      record:{
        id: this.dataId,
        model: this.dataModel
      },
      items: JSON.parse(this.dataItems),
      other_orders: JSON.parse(this.dataOtherOrders),
      data_order: JSON.parse(this.dataOrder),
      empty_item: {
        link:"",
        description:""
      }
    }
  },
  computed:{
    all_links: function(){
      var items = []
      if (this.other_orders.length != 0 && this.data_order.state.name != 'CANCELED'){
        this.other_orders.forEach(order => {
          if(order.state.name != "CANCELED"){
            order.links.forEach(link => {
              if(link.deleted_at === null){
                items.push(link)
              }
            })
          }
        })
      }else{
        items = this.items
      }
      return items
    },
    emptyItems: function(){
      return this.all_links.length === 0;
    },
  },
  methods:{
    isImage: function(url) {
      if (!url) return false;
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp', '.svg'];
      const lowerUrl = url.toLowerCase();
      return imageExtensions.some(ext => lowerUrl.includes(ext));
    },
    truncateUrl: function(url) {
      if (!url) return '';
      if (url.length <= 50) return url;
      return url.substring(0, 47) + '...';
    },
    showLink:function(path){
    },
    retrieveLinks:function(){
      let self = this; 
      BackendService
        .links(JSON.stringify({
          query:{
            linkable_type: self.record.model,
            linkable_id: self.record.id
          }
        }))
        .then((response)=>{
          self.result = response;
          if (response.isOk){
            self.items = response.links;
          }
        })
        .finally(()=>{
        })
    },
    updateLink:function(params){
      const self = this;
      this.state.sending = true;
      BackendService
        .link_update(params)
        .then((response) => {
          if (response.isOk) {
            location.reload();
          }
        })
        .catch(() => {
          self.result.isError = true;
          self.result.notice = "error_promise";
          self.state.sending = false;
        });
    },
    createNewLink:function(params){
      const self = this;
      this.state.sending = true;
      BackendService
        .create_link(params)
        .then((response)=>{
          self.result = response;
          if (response.isOk){
            location.reload();
          }
        })
        .catch(()=>{
          self.result.isError=true;
          self.result.notice='error_promise';
          self.state.sending = false;
        })
        .finally(()=>{
        })
    },
  }
}
</script>

<style scoped>
.links-styled-panel {
  padding: 1rem;
}

.links-styled-table {
  font-size: 0.85rem;
}

.links-styled-table thead th {
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.5rem 0.75rem;
  font-weight: 600;
  color: #4b5563;
}

.links-styled-table tbody td {
  vertical-align: middle;
  padding: 0.5rem 0.6rem;
}

.tw-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tw-max-w-xs {
  max-width: 20rem;
}
</style>
